import React, { useState, useEffect } from "react";
import "../../ViewInfo.css";
import { TextField, Button, MenuItem, Menu } from "@mui/material";
import { Get_One_Nested_Prop_From_MongoDB } from "../../../api/Get_One_Nested_Prop_From_MongoDB";
import { useParams } from "react-router-dom";
import { Update_To_MongoDB_By_ID } from "../../../api/Update_To_MongoDB_By_ID";
import removeUnderscores from "../../../../functions/removeUnderscores";
import { StudentuseAuth } from "../../../security/StudentUseAuth";
import { Student_Get_One_Nested_Prop_From_MongoDB } from "../../../api/Student_Get_One_Nested_Prop_From_MongoDB";
import { Student_Update_To_MongoDB_By_ID } from "../../../api/Student_Update_To_MongoDB_By_ID";
import { Link } from "react-router-dom";
import WEFChangePage from "../../../components/ChangePage/WEFChangePage";

function ViewGeneralInfo() {
  const { id } = useParams();
  const { logoutStudent } = StudentuseAuth();

  const [formGeneralInfo, setformGeneralInfo] = useState({
    Full_name_of_the_person_completing_the_form: "",
    Email_of_the_person_completing_the_form: "",
    completing_the_form_Your_relationship_to_the_student: "",
    Contact_1_full_name: "",
    Contact_1_Relationship_to_the_student: "",
    Contact_1_Email_address: "",
    Contact_1_Mobile_phone_number_inc_country_code: "",
    Contact_1_Confirmation_is_English_speaking: "",

    //Student email address:
  });

  const [SEFProgress, setSEFProgress] = useState({
    GeneralInfo: "",
  });

  useEffect(() => {
    Student_Get_One_Nested_Prop_From_MongoDB(
      "Registers_2025",
      "All",
      localStorage.getItem("Student_id"),

      "SEFGeneralInfo",
      setformGeneralInfo,
      logoutStudent
    );
    Student_Get_One_Nested_Prop_From_MongoDB(
      "Registers_2025",
      "All",
      localStorage.getItem("Student_id"),

      "SEFProgress",
      setSEFProgress,
      logoutStudent
    );
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setformGeneralInfo((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const [status, setStatus] = useState(false);

  const handleSaveProgress = () => {
    Student_Update_To_MongoDB_By_ID(
      {
        SEFGeneralInfo: formGeneralInfo,
        "SEFProgress.GeneralInfo": "In_Progress",
      },
      "Registers_2025",
      "All",
      setStatus,
      localStorage.getItem("Student_id"),

      "Your progress has been saved, you may now navigate to another page using the buttons at the bottom or close this tab",
      logoutStudent
    );
    setPageButtonStatus(true);
  };

  const handleSubmit = () => {
    Student_Update_To_MongoDB_By_ID(
      {
        SEFGeneralInfo: formGeneralInfo,
        //SEFProgress: { GeneralInfo: "Complete" },
        "SEFProgress.GeneralInfo": "Complete",
      },
      "Registers_2025",
      "All",
      setStatus,
      localStorage.getItem("Student_id"),

      "This page has been submitted, you may now navigate to another page using the buttons at the bottom or close this tab",
      logoutStudent
    );
    setSEFProgress({
      GeneralInfo: "Complete",
    });
    setPageButtonStatus(true);
  };

  const isFormComplete =
    formGeneralInfo &&
    formGeneralInfo.completing_the_form_Full_name_of_the_person &&
    formGeneralInfo.completing_the_form_Email_of_the_person &&
    ((formGeneralInfo.completing_the_form_Your_relationship_to_the_student &&
      formGeneralInfo.completing_the_form_Your_relationship_to_the_student !==
        "Legal Guardian") ||
      formGeneralInfo.completing_the_form_relationship_specified) &&
    formGeneralInfo.Contact_1_full_name &&
    formGeneralInfo.Contact_1_Relationship_to_the_student &&
    formGeneralInfo.Contact_1_Email_address &&
    formGeneralInfo.Contact_1_Mobile_phone_number_inc_country_code &&
    formGeneralInfo.Contact_1_Confirmation_is_English_speaking;

  const [PageButtonStatus, setPageButtonStatus] = useState(false);

  return (
    <div className="view-basic-info-container">
      <h1>General Information</h1>
      {SEFProgress &&
      SEFProgress.GeneralInfo &&
      (SEFProgress.GeneralInfo === "Complete" ||
        SEFProgress.GeneralInfo === "Awaiting_Review") ? (
        <strong>
          If you need to make further changes, please contact InvestIN at
          info@investin.org or speak to your known contact
        </strong>
      ) : (
        ""
      )}

      <form className="view-basic-info-form">
        <TextField
          label={removeUnderscores(
            "Full_name_of_the_person_completing_the_form"
          )}
          variant="outlined"
          fullWidth
          required
          name="completing_the_form_Full_name_of_the_person"
          value={formGeneralInfo?.completing_the_form_Full_name_of_the_person}
          onChange={handleChange}
          InputProps={{
            style: {
              backgroundColor: "white",
              textAlign: "left",
              color: "black", // Set the font color to black
            },
          }}
          InputLabelProps={{
            style: {
              fontSize: "1.2rem", // Increase the font size of the label
              color: "black", // Set the label color to black
            },
            shrink: true,
          }}
        />
        <TextField
          label={removeUnderscores("Email_of_the_person_completing_the_form")}
          variant="outlined"
          fullWidth
          required
          name="completing_the_form_Email_of_the_person"
          value={formGeneralInfo?.completing_the_form_Email_of_the_person}
          onChange={handleChange}
          InputProps={{
            style: {
              backgroundColor: "white",
              textAlign: "left",
              color: "black", // Set the font color to black
            },
          }}
          InputLabelProps={{
            style: {
              fontSize: "1.2rem", // Increase the font size of the label
              color: "black", // Set the label color to black
            },
            shrink: true,
          }}
        />
        <TextField
          label={removeUnderscores("Your_relationship_to_the_student")}
          variant="outlined"
          fullWidth
          required
          name="completing_the_form_Your_relationship_to_the_student"
          value={
            formGeneralInfo?.completing_the_form_Your_relationship_to_the_student
          }
          onChange={handleChange}
          InputProps={{
            style: {
              backgroundColor: "white",
              textAlign: "left",
              color: "black", // Set the font color to black
            },
          }}
          InputLabelProps={{
            style: {
              fontSize: "1.2rem", // Increase the font size of the label
              color: "black", // Set the label color to black
            },
            shrink: true,
          }}
          select
        >
          <MenuItem value="">-----</MenuItem>
          <MenuItem value="Mother">Mother</MenuItem>
          <MenuItem value="Father">Father</MenuItem>
          <MenuItem value="Legal Guardian">
            Legal Guardian (With Parental Responsibilities)
          </MenuItem>
        </TextField>
        {formGeneralInfo?.completing_the_form_Your_relationship_to_the_student ===
        "Legal Guardian" ? (
          <>
            <TextField
              label={removeUnderscores(
                "Please_specify_your_relationship_to_the_student"
              )}
              variant="outlined"
              fullWidth
              required
              name="completing_the_form_relationship_specified"
              value={
                formGeneralInfo?.completing_the_form_relationship_specified
              }
              onChange={handleChange}
              InputProps={{
                style: {
                  backgroundColor: "white",
                  textAlign: "left",
                  color: "black", // Set the font color to black
                },
              }}
              InputLabelProps={{
                style: {
                  fontSize: "1.2rem", // Increase the font size of the label
                  color: "black", // Set the label color to black
                },
              }}
            />
          </>
        ) : (
          <></>
        )}
        InvestIN requires an emergency contact for each student attending an
        InvestIN weekend programme. The contact must be a parent or legal
        guardian.
        <TextField
          label={removeUnderscores("Contact_1_full_name")}
          variant="outlined"
          fullWidth
          required
          name="Contact_1_full_name"
          value={formGeneralInfo?.Contact_1_full_name}
          onChange={handleChange}
          InputProps={{
            style: {
              backgroundColor: "white",
              textAlign: "left",
              color: "black", // Set the font color to black
            },
          }}
          InputLabelProps={{
            style: {
              fontSize: "1.2rem", // Increase the font size of the label
              color: "black", // Set the label color to black
            },
            shrink: true,
          }}
        />{" "}
        <TextField
          label={removeUnderscores("Contact_1_relationship_to_the_student")}
          variant="outlined"
          fullWidth
          required
          name="Contact_1_Relationship_to_the_student"
          value={formGeneralInfo?.Contact_1_Relationship_to_the_student}
          onChange={handleChange}
          InputProps={{
            style: {
              backgroundColor: "white",
              textAlign: "left",
              color: "black", // Set the font color to black
            },
          }}
          InputLabelProps={{
            style: {
              fontSize: "1.2rem", // Increase the font size of the label
              color: "black", // Set the label color to black
            },
            shrink: true,
          }}
          select
        >
          <MenuItem value="">-----</MenuItem>
          <MenuItem value="Mother">Mother</MenuItem>
          <MenuItem value="Father">Father</MenuItem>
          <MenuItem value="Legal Guardian">Legal Guardian</MenuItem>
        </TextField>
        <TextField
          label={removeUnderscores("Contact_1_email_address")}
          variant="outlined"
          fullWidth
          required
          name="Contact_1_Email_address"
          value={formGeneralInfo?.Contact_1_Email_address}
          onChange={handleChange}
          InputProps={{
            style: {
              backgroundColor: "white",
              textAlign: "left",
              color: "black", // Set the font color to black
            },
          }}
          InputLabelProps={{
            style: {
              fontSize: "1.2rem", // Increase the font size of the label
              color: "black", // Set the label color to black
            },
            shrink: true,
          }}
        />{" "}
        <TextField
          label={removeUnderscores(
            "Contact_1_mobile_phone_number_inc_country_code"
          )}
          variant="outlined"
          fullWidth
          required
          name="Contact_1_Mobile_phone_number_inc_country_code"
          value={
            formGeneralInfo?.Contact_1_Mobile_phone_number_inc_country_code
          }
          onChange={handleChange}
          InputProps={{
            style: {
              backgroundColor: "white",
              textAlign: "left",
              color: "black", // Set the font color to black
            },
          }}
          InputLabelProps={{
            style: {
              fontSize: "1.2rem", // Increase the font size of the label
              color: "black", // Set the label color to black
            },
            shrink: true,
          }}
        />{" "}
        <TextField
          label={removeUnderscores(
            "Contact_1:_Confirmation_the_contact_is_english_speaking"
          )}
          variant="outlined"
          fullWidth
          required
          name="Contact_1_Confirmation_is_English_speaking"
          value={formGeneralInfo?.Contact_1_Confirmation_is_English_speaking}
          onChange={handleChange}
          InputProps={{
            style: {
              backgroundColor: "white",
              textAlign: "left",
              color: "black", // Set the font color to black
            },
          }}
          InputLabelProps={{
            style: {
              fontSize: "1.2rem", // Increase the font size of the label
              color: "black", // Set the label color to black
            },
            shrink: true,
          }}
          select
        >
          <MenuItem value="">-----</MenuItem>
          <MenuItem value="Yes">Yes</MenuItem>
          <MenuItem value="No">No</MenuItem>
        </TextField>{" "}
        <WEFChangePage
          Page={"GeneralInfo"}
          PageButtonStatus={PageButtonStatus}
        />
        <div className="view-basic-info-buttons">
          <Button
            variant="contained"
            color="primary"
            onClick={handleSaveProgress}
            disabled={
              status ||
              (SEFProgress &&
                SEFProgress.GeneralInfo &&
                (SEFProgress.GeneralInfo === "Complete" ||
                  SEFProgress.GeneralInfo === "Awaiting_Review"))
            }
          >
            Save Progress
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleSubmit}
            disabled={
              !isFormComplete ||
              status ||
              (SEFProgress &&
                SEFProgress.GeneralInfo &&
                (SEFProgress.GeneralInfo === "Complete" ||
                  SEFProgress.GeneralInfo === "Awaiting_Review"))
            }
          >
            Submit
          </Button>
        </div>
      </form>
    </div>
  );
}

export default ViewGeneralInfo;
